import { EventTriggerType, Trigger } from '../../domain';
import { TriggerType } from './components/TriggerType';
import { TriggerValueDetail } from './components/TriggerValueDetail';

interface Props {
  trigger: Trigger;
  triggerType: EventTriggerType;
}

export default function PacificaBuilderTradesTriggerDetails({ trigger, triggerType }: Props) {
  const builderCode = (trigger.context?.builderCode as string) || 'N/A';

  return (
    <div className="tw:flex tw:flex-row tw:gap-6">
      <TriggerType eventType={triggerType} />
      <TriggerValueDetail label="Builder Code" value={builderCode} />
    </div>
  );
}
